import { FC } from "react";
import { useGetItemsWithDetailsQuery } from "src/store/slices/item/item.api";
import DiscountCard from "../DiscountCard/DiscountCard";
import DiscountCardSkeleton from "../DiscountCardSkeleton/DiscountCardSkeleton";
import NoData from "@Components/NoData/NoData";
import { useDiscountsListing } from "../../context/DiscountsListingContext";
import { useTranslation } from "react-i18next";
import { toLanguage } from "src/i18n/direction";
import useSharedVoucherShape from "./hooks/useSharedVoucherShape";
import { Brand } from "src/store/slices/item/item.type";
import { DiscountsItem } from "src/store/slices/item/subitems/discounts.types";

const DiscountsListLoading = () => {
  const { shapeRef, seamRef, src } = useSharedVoucherShape();

  return (
    <div className="grid w-full grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-5">
      {Array.from({ length: 10 }).map((_, i) => (
        <DiscountCardSkeleton
          key={`discounts-${i}`}
          background={src}
          shapeRef={i === 0 ? shapeRef : undefined}
          seamRef={i === 0 ? seamRef : undefined}
        />
      ))}
    </div>
  );
};

const DiscountsGrid: FC<{ brands: Brand<DiscountsItem>[] }> = ({ brands }) => {
  const { shapeRef, seamRef, src } = useSharedVoucherShape();

  return (
    <div className="grid w-full grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-5">
      {brands.map((brand, i) => (
        <DiscountCard
          key={brand.code}
          {...brand}
          background={src}
          shapeRef={i === 0 ? shapeRef : undefined}
          seamRef={i === 0 ? seamRef : undefined}
        />
      ))}
    </div>
  );
};

export default function DiscountsList() {
  const { filters } = useDiscountsListing();
  const { i18n } = useTranslation();
  const { isFetching, data, error } = useGetItemsWithDetailsQuery({
    moduleType: "Discounts",
    ...filters,
    Page: 1,
    PageSize: 100000,
    lang: toLanguage(i18n.language),
  });
  if (isFetching) return <DiscountsListLoading />;
  if (error || !data?.length)
    return (
      <div className="flex min-h-[50vh] w-full items-center justify-center">
        <NoData />
      </div>
    );

  return <DiscountsGrid brands={data} />;
}
